import React from 'react';
import './PopupStyles.css';

const PopupStorageError = ({ errorInfo }) => {
    if (!errorInfo) return null;

    return (
        <div className="popup-container">
            <div className="popup-header">
                <img src="/images/nslmail_sm.gif" alt="NslMail" className="popup-header-logo" />
                <span className="popup-header-page-name">{errorInfo.title}</span>
            </div>

            <div className="popup-content-padding">
                <div style={{
                    padding: '20px',
                    backgroundColor: '#fef2f2',
                    border: '1px solid #fecaca',
                    borderRadius: '4px',
                    marginBottom: '20px'
                }}>
                    <p style={{
                        margin: '0 0 15px 0',
                        color: '#991b1b',
                        fontWeight: 'bold'
                    }}>
                        {errorInfo.message}
                    </p>

                    {errorInfo.suggestions && errorInfo.suggestions.length > 0 && (
                        <>
                            <p style={{
                                margin: '15px 0 10px 0',
                                fontWeight: 'bold',
                                color: '#7f1d1d'
                            }}>
                                Try these solutions:
                            </p>
                            <ul style={{
                                margin: '0',
                                paddingLeft: '20px',
                                color: '#991b1b'
                            }}>
                                {errorInfo.suggestions.map((suggestion, index) => (
                                    <li key={index} style={{ marginBottom: '5px' }}>
                                        {suggestion}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>

                <div style={{ textAlign: 'center' }}>
                    <button
                        onClick={() => window.location.reload()}
                        className="popup-link-button"
                        style={{ marginRight: '10px' }}
                    >
                        Try Again
                    </button>
                    <button
                        onClick={() => window.open(window.location.origin + '/aliases', '_blank')}
                        className="popup-link-button"
                    >
                        Open in New Tab
                    </button>
                </div>

                <div style={{
                    marginTop: '20px',
                    padding: '15px',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '4px',
                    fontSize: '12px',
                    color: '#6b7280'
                }}>
                    <p style={{ margin: '0 0 10px 0', fontWeight: 'bold' }}>
                        Why is this happening?
                    </p>
                    <p style={{ margin: '0' }}>
                        Modern browsers have security features that prevent websites from accessing
                        storage when opened in certain contexts (like popups from other websites).
                        This protects your privacy by preventing cross-site tracking. The NslMail
                        bookmarklet works on most sites, but some websites have strict security
                        policies that interfere with it.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PopupStorageError;
